// frontend/src/utils/policy/enforceResponsePolicy.js
//
// FINAL RESPONSE EXECUTION BOUNDARY
// ---------------------------------
// This is the single public entry point for enforcing response policy.
// Callers provide a candidate response plus runtime context; this module owns
// provider resolution, validation, transformation, and audit logging.
//
// Chat.js should only invoke this boundary. It must not interpret policy rules.
// Future server/API orchestration can call the same function or replace its
// provider list without moving policy meaning back into Chat.js.

import { debugLog } from '../logging/debugLog';
import resolveEffectiveResponsePolicy from './resolveEffectiveResponsePolicy';
import validateResponseAgainstPolicy from './validateResponseAgainstPolicy';
import applyResponsePolicyDecision from './applyResponsePolicyDecision';

function normalizeText(value = '') {
  return String(value || '').replace(/\s+/g, ' ').trim();
}

export function enforceResponsePolicy(candidateResponse = '', context = {}, options = {}) {
  const candidate = normalizeText(candidateResponse);
  const stage = options.stage || 'final_output';
  const policyResolution = resolveEffectiveResponsePolicy(context);
  const effectivePolicy = policyResolution.effectivePolicy;
  const validation = validateResponseAgainstPolicy(candidate, effectivePolicy);
  const finalResponse = applyResponsePolicyDecision(validation, effectivePolicy);

  debugLog(`🛡️ [ResponsePolicy:${stage}] Effective policy:`, effectivePolicy);
  debugLog(`🛡️ [ResponsePolicy:${stage}] Validation result:`, validation);
  debugLog(`🛡️ [ResponsePolicy:${stage}] Final response:`, finalResponse);

  return {
    response: normalizeText(finalResponse),
    effectivePolicy,
    validation,
    policyResolution,
  };
}

export default enforceResponsePolicy;
